import React from 'react';
import Config from '../../../../AppConfig';

interface Props {
	source: string;
	alt: string;
	style?: object;
	className?: string;
}

const Image: React.FunctionComponent<Props> = props => (
	<img
		src={`${Config.aemImageEnv}${props.source}`}
		alt={props.alt}
		style={props.style}
		className={props.className}
	/>
);

export default Image;
